var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReapet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7258 5.89989L24.101 0.275064C23.8329 0.00694779 23.4298 -0.0736747 23.0791 0.0725707C22.7285 0.218816 22.4998 0.558181 22.4998 0.936919V3.74933H10.3127C4.61659 3.74933 0.000488281 8.36544 0.000488281 14.0615C0.000488281 14.579 0.420475 14.999 0.937959 14.999H4.68784C5.20533 14.999 5.62531 14.579 5.62531 14.0615C5.62531 11.4722 7.72337 9.37416 10.3127 9.37416H22.4998V12.1866C22.4998 12.5653 22.7285 12.9084 23.0791 13.0528C23.4298 13.199 23.8329 13.1184 24.101 12.8503L29.7258 7.22547C30.0914 6.85986 30.0914 6.2655 29.7258 5.89989Z",
    fill: "#396AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0621 14.9991H25.3122C24.7947 14.9991 24.3747 15.4191 24.3747 15.9366C24.3747 18.5259 22.2766 20.624 19.6874 20.624H7.50023V17.8116C7.50023 17.4328 7.27149 17.0897 6.92088 16.9453C6.57026 16.801 6.16903 16.8816 5.89903 17.1497L0.27421 22.7745C-0.0914034 23.1402 -0.0914034 23.7345 0.27421 24.1001L5.89903 29.725C6.16715 29.9931 6.57026 30.0737 6.92088 29.9275C7.27149 29.7812 7.50023 29.44 7.50023 29.0612V26.2488H19.6874C25.3834 26.2488 29.9995 21.6327 29.9995 15.9366C29.9995 15.4191 29.5795 14.9991 29.0621 14.9991Z",
    fill: "#396AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReapet);
export default __webpack_public_path__ + "static/media/reapet.7f782455675479140214db6de5689405.svg";
export { ForwardRef as ReactComponent };